<div class="row mt-4">
    <div class="col-md-12 fs20 text-center font-bold text-red-600">
        <span>TWO FORMS OF ID ARE REQUIRED TO LODGE GST AS PER ATO</span>
    </div>
</div>

<div class="row">   
    <div class="col-md-5">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-12">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; TWO FORMS OF ID - COMPULSORY*</div>
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    TWO FORMS OF ID - COMPULSORY*
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <div class="row">
                        <div class="col-md-12 text-center"  *ngIf="gstCase.primaryId === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs20" (click)="attachFile(false, 'id1', 'ID Proof - 1', 'GstP1')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload ID Proof 1</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="gstCase.primaryId > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> ID Proof 1 Uploaded</span>  
                        </div>

                        <div class="col-12 my-4 text-center fs18 bold">
                            == & ==
                        </div>

                        <div class="col-md-12 text-center" *ngIf="gstCase.secondaryId === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs20" (click)="attachFile(false, 'id2', 'ID Proof - 2', 'GstS1')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload ID Proof 2</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="gstCase.secondaryId > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> ID Proof 2 Uploaded</span>  
                        </div>
                    </div>
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
    </div>
    <div class="col-md-2 my-auto text-center fs18 bold">
        == OR ==
    </div>
    <div class="col-md-5">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-12">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; SELFIE WITH PHOTO ID IN HAND</div>
                        </div>
                        <div class="col-3 text-right">
                            <!-- <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f3', title)">Info</button> -->
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    SELFIE WITH PHOTO ID IN HAND
                                    <!-- &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f3', title)">Info</a> -->
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-md-12 text-center w-full">
                            <img src="assets/images/selfie.jpg" style="height: 100px;" alt="selfie" class="d-block mx-auto" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center"  *ngIf="gstCase.primaryId2 === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs20" (click)="attachFile(false, 'id0', 'Selfie With Photo ID', 'GstP0')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload - Selfie With Photo ID</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="gstCase.primaryId2 > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> Selfie with Photo ID - Uploaded</span>  
                        </div>
                      
                    </div>
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
    </div>
   
</div>



<!-- <div class="row">
    <div class="col-md-5">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-9">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon fas fa-adjust"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; {{title}}</div>
                        </div>
                        <div class="col-3 text-right">
                            <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f3', title)">Info</button>
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon fas fa-adjust"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    {{title}} &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f3', title)">Info</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-md-12">
                            <span class="fs14 bold c-danger">
                                Please upload one of the below Photo ID
                            </span>
                            <ul class="ml-3 bold fs11">
                                <li><i class="fas fa-star fs10"></i> Australian Driver Licence </li>
                                <li><i class="fas fa-star fs10"></i> Australian Digital or Overseas Driver Licence</li>
                                <li><i class="fas fa-star fs10"></i> Australian/Overseas or UN Passport</li>
                                <li><i class="fas fa-star fs10"></i> Proof Of Age Card</li>
                                <li><i class="fas fa-star fs10"></i> International Travel Document</li>
                                <li><i class="fas fa-star fs10"></i> Immi Card</li>
                                <li><i class="fas fa-star fs10"></i> Naional Identity Card - Foreign/UN</li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5 col-sm-12 text-center">
                            <a *ngIf="gstCase.primaryId === 0" mat-raised-button color="primary" class="cpanel-btn c-white" (click)="attachFile(false, 'Licence', 'Driver Licence Front & Back')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Driver Licence</a>
                        </div>
                        <div class="col-md-2 col-sm-12 text-center fs14 bold my-auto">
                            <span>Or</span>
                        </div>
                        <div class="col-md-5 col-sm-12 text-center">
                            <a *ngIf="gstCase.primaryId === 0" mat-raised-button color="primary" class="cpanel-btn c-white" (click)="attachFile(false, 'Photo ID', 'Photo ID Proof')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Other Photo ID</a>
                        </div>
                    </div>
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
    </div>
    <div class="col-md-1 my-auto text-center fs18 bold">
        === OR ===
    </div>
    <div class="col-md-6">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-9">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon fas fa-adjust"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; Non Photo ID Proof</div>
                        </div>
                        <div class="col-3 text-right">
                            <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f3', title)">Info</button>
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon fas fa-adjust"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    Non Photo ID Proof &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f3', title)">Info</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-md-5">
                            <span class="fs14 bold c-danger">
                                Please upload Primary ID
                            </span>
                            <ul class="ml-3 bold fs11">
                                <li><i class="fas fa-star fs10"></i> Australian/Foreign Birth Certificate</li>
                                <li><i class="fas fa-star fs10"></i> Australian/Foreign Citizen Certificate</li>
                                <li><i class="fas fa-star fs10"></i> Centerlink Card/Health/Senior Card</li>
                            </ul>
                           
                        </div>
                        <div class="col-md-2 text-center my-auto">
                            <span class="fs16 bold c-dark">&</span>
                        </div>
                        <div class="col-md-5">
                            <span class="fs14 bold c-danger">
                                Please upload Secondary ID
                            </span>
                            <ul class="ml-3 bold fs11">
                                <li><i class="fas fa-star fs10"></i> ATO NOA Or Other Letter</li>
                                <li><i class="fas fa-star fs10"></i> Centrelink Or CSA Letter</li>
                                <li><i class="fas fa-star fs10"></i> Medicare Card</li>
                                <li><i class="fas fa-star fs10"></i> Rates / Power / Gass Bill</li>
                                <li><i class="fas fa-star fs10"></i> Electoral Roll Details</li>
                                <li><i class="fas fa-star fs10"></i> Other</li>
                            </ul>
                          
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5 mb-3 text-center">
                            <a *ngIf="gstCase.secondaryId === 0" mat-raised-button class="cpanel-btn c-blue bold" (click)="attachSecondaryFile(false)"> <i class="fas fa-upload tbl-btn c-blue bold"></i> Upload Primary ID</a>
                            <div *ngIf="gstCase.secondaryId > 0">
                                <a class="cpanel-btn bold" (click)="viewSecondaryFile()" mat-raised-button> <i class="fas fa-search c-success fs14"></i> <span class="c-success bold ml5">View</span></a>
                                <span *ngIf="gstCase.statusId < 5">&nbsp;|&nbsp;</span>
                                <a class="cpanel-btn bold" *ngIf="gstCase.statusId < 5" (click)="attachSecondaryFile(true)" mat-raised-button> <i class="fas fa-redo-alt c-purple fs14"></i> <span class="c-purple bold ml5">Re-Upload</span></a>
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-12 text-center fs16 bold">
                            <span>&</span>
                        </div>
                        <div class="col-md-5 text-center">
                            <a *ngIf="gstCase.secondaryId2 === 0" mat-raised-button class="cpanel-btn c-blue bold" (click)="attachSecondaryFile2(false)"> <i class="fas fa-upload tbl-btn c-blue bold"></i> Upload Secondary ID</a>
                            <div *ngIf="gstCase.secondaryId2 > 0">
                                <a class="cpanel-btn bold" (click)="viewSecondaryFile2()" mat-raised-button> <i class="fas fa-search c-success fs14"></i> <span class="c-success bold ml5">View</span></a>
                                <span *ngIf="gstCase.statusId < 5">&nbsp;|&nbsp;</span>
                                <a class="cpanel-btn bold" *ngIf="gstCase.statusId < 5" (click)="attachSecondaryFile2(true)" mat-raised-button> <i class="fas fa-redo-alt c-purple fs14"></i> <span class="c-purple bold ml5">Re-Upload</span></a>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
    </div>
</div> -->